import React from "react";

const hows = [
    {
        text: 'Describe what you need and get matched to local pros.',
        image:
        {
            alt: 'contractors',
            path: '/images/icons/kpp/how-hometown-works-icon-1.webp'  // demolition: './contractors.png'
        }
    },
    {
        text: 'Get quotes from top-rated companies.',
        image:
        {
            alt: 'contractor',
            path: '/images/icons/kpp/how-hometown-works-icon-2.webp' // demolition: './contractor.png'
        }
    },
    {
        text: 'Compare quotes and hire the right pro for the job.',
        image:
        {
            alt: 'star contractor',
            path: '/images/icons/kpp/how-hometown-works-icon-3.webp' // demolition: './star.png'
        }
    }
]

const bookHow = [
    {
        text: 'Compare instant quotes',
        image:
        {
            alt: 'compare-quotes',
            path: '/images/icons/compare-quotes-icon.webp'
        }
    },
    {
        text: 'Choose your dumpster',
        image:
        {
            alt: 'choose-dumpster',
            path: '/images/icons/choose-dumpster-icon.webp'
        }
    },
    {
        text: 'Schedule online easily',
        image:
        {
            alt: 'schedule-online',
            path: '/images/icons/schedule-online-icon.webp'
        }
    }
]

export default class HowNearMeDumpster extends React.Component 
{    
    data = this.props.book ? bookHow : hows;
    class = (this.props.book && this.props.page === 'home') ? "container-fuild how-demolition bookHowContainerHome" : (this.props.page != 'home' ? "container-fuild how-demolition nearmeHowContainer" : "container-fuild how-demolition nearmeHowContainerHome")
    render() 
    {        
        return (
            <div className={this.class}>   
                <div class="container"> 
                    <div className="row m-0">  
                        <h2>{this.props.title? this.props.title : 'How Hometown Works'}</h2>            
                        <div className="hows">
                            <div className="row">
                            {
                                this.data.map((how, index) =>
                                {                                                 
                                    return(
                                        <div className="col-lg-4">
                                            <div className="how nearmeHow">
                                                <div className={index != (hows.length -1) ? "image" : "image lastIcon"}>
                                                    <img src={how.image.path} alt={how.image.alt} />
                                                    {(index === 0 || index === 1) && <hr className="dottedLine"/>}
                                                </div>
                                                <div className="text">
                                                    <p>{how.text}</p>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })
                            }
                            </div> 
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};